import React from "react";
import GuideCard from "../../components/cards/mobileView/GuideCard";
import MobileHeader from "../../layout/MobileHeader";
import MobileHeaderSearch from "../../components/MobileHeaderSearch";
import { useFetch } from "../../hooks/useFetch";
import { getAllCities } from "../../apis";
import Location from '../../assets/images/card/4.png'
import Icon from "../../components/Icon";
import { faXmark } from "@fortawesome/free-solid-svg-icons";


const Guides = ({ guides, filters = [], setFilters = () => {} }) => {
  const [locations] = useFetch(getAllCities, [])

  return (
    <>
      <MobileHeader height={"237px"}>
        <MobileHeaderSearch placeholder="Search Guides" onSearch={(value) => setFilters({ ...filters, search: value })} />
      </MobileHeader>

      <section className="mobile-top-space px-2">

        <div className="hidden-in-desktop ">
          <ul className="list-unstyled mobileScrollBar d-flex gap-3 px-3">
            <li >
              <div className={`rounded-circle ${ filters.city === "Mathura" && "border border-2 border-dark"}`} style={{ width: "75px", height: "75px" }} onClick={() => setFilters({ ...filters, city: "Mathura"})}>
                <img
                  src={Location}
                  className="w-100 h-100 rounded-circle"
                />
              </div>
              <p className="mb-0 text-center">Near By</p>
            </li>
            {locations?.map((location, i) => (
              <li key={i}>
                <div className="">
                  <div
                    className={` rounded-circle ${ location.name == filters.city && "border border-2 border-dark"}`}
                    style={{ width: "75px", height: "75px" }}
                    onClick={() => setFilters({ ...filters, city: location.name })}
                  >
                    <img
                      src={location?.file?.Url}
                      className="w-100 h-100 rounded-circle"
                      alt=""
                    />
                  </div>
                  <p className="mb-0 text-center">{location.name}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {filters.search && <h4 className="custom-text-color mt-5">Search: { filters.search } <Icon icon={faXmark} className="ms-3" onClick={() => setFilters({})}/></h4>}

        <div className="top-heading mt-4">Best Guides, Rated Services.</div>
        <div className="top-destinations-subHeading mb-3">
          Making the Most of Your Travel Experience in 2024
        </div>


        <div className="">
          {guides?.map((guide, i) => (
            <div key={i}>
              <GuideCard data={guide} />

            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Guides;
